import { GIVING_SCRIPTURE } from "@/content/giving";
import { Button } from "@/components/ui/Button";
import { Container, Eyebrow } from "@/components/ui/Primitives";
import { Reveal } from "@/components/motion/Reveal";
import { Icon, type IconName } from "@/components/ui/Icon";

const WAYS: { icon: IconName; title: string; text: string }[] = [
  { icon: "shield", title: "Give online", text: "Card, bank and wallet payments on our secure giving page." },
  { icon: "church", title: "Bank transfer", text: "Naira accounts for tithes, offerings and seeds." },
  { icon: "globe", title: "From abroad", text: "International giving, including Zelle from the US." },
];

/** Giving, presented with care: purpose and trust first, details on the Give page. */
export function Give() {
  return (
    <section className="give-teaser" aria-labelledby="give-title">
      <Container>
        <div className="give-teaser__grid">
          <div>
            <Reveal>
              <Eyebrow index="11">Give</Eyebrow>
            </Reveal>
            <Reveal delay={60}>
              <h2 id="give-title" className="give-teaser__title">
                Partner with what <em>God is doing.</em>
              </h2>
            </Reveal>
            <Reveal delay={120}>
              <p className="give-teaser__text">
                Your giving carries the Word further — into services, outreach, care for families and the expansion of the quality living mandate.
              </p>
              <p className="give-teaser__verse">
                “{GIVING_SCRIPTURE.text}” <span>— {GIVING_SCRIPTURE.reference}</span>
              </p>
            </Reveal>
            <Reveal delay={160}>
              <Button to="/give" variant="flame" size="lg" icon="heart">
                Give
              </Button>
            </Reveal>
          </div>
          <ul className="give-teaser__ways">
            {WAYS.map((w, i) => (
              <Reveal as="li" key={w.title} delay={i * 90} className="give-way">
                <span className="give-way__icon">
                  <Icon name={w.icon} size={22} />
                </span>
                <span>
                  <span className="give-way__title">{w.title}</span>
                  <span className="give-way__text">{w.text}</span>
                </span>
              </Reveal>
            ))}
          </ul>
        </div>
      </Container>
    </section>
  );
}
